import { fetchBestRates, SCENARIO_TYPES } from '@ratehub/mtg-common';

import { DEFAULT_BEST_PURCHASE_PARAMS, MORTGAGE_TYPES } from '../definitions/MortgageTerms';


async function fetchBestMortgageProviderRates({ typeTerms, city, province }) {
    const rates = await fetchBestRates(SCENARIO_TYPES.PURCHASE, {
        ...DEFAULT_BEST_PURCHASE_PARAMS,
        type: typeTerms.map(typeTerm => typeTerm.type),
        term: typeTerms.map(typeTerm => typeTerm.term),
        city,
        province,
    });

    return typeTerms.map(typeTerm => {
        const rate = rates.find(r => r.type === typeTerm.type && r.term === typeTerm.term);

        return rate
            ? {
                providerSlug: rate.provider.slug,
                lenderType: rate.provider.lenderType,
                deltaPrime: rate.type === MORTGAGE_TYPES.VARIABLE
                    ? rate.value - rates.primeRate
                    : undefined,
                lastUpdatedDate: rates.lastUpdated,
                ...rate,
            }
            : undefined;
    });
}

export default fetchBestMortgageProviderRates;
